export default __webpack_public_path__ + "static/media/dress9.e766e534.jpeg";